import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

export const useSubjects = () => {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSubjects = async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('subjects')
        .select('*')
        .order('code', { ascending: true });
      
      if (error) throw error;
      setSubjects(data || []);
    } catch (error) {
      setError(error.message);
      console.error('Error fetching subjects:', error);
    } finally {
      setLoading(false);
    }
  };

  const addSubject = async (subjectData) => {
    try {
      const { data, error } = await supabase
        .from('subjects')
        .insert([subjectData])
        .select();
      
      if (error) throw error;
      setSubjects(prev => [...prev, data[0]]);
      return { success: true, data: data[0] };
    } catch (error) {
      setError(error.message);
      console.error('Error adding subject:', error);
      return { success: false, error: error.message };
    }
  };

  const updateSubject = async (id, updates) => {
    try {
      const { data, error } = await supabase
        .from('subjects')
        .update(updates)
        .eq('id', id)
        .select();
      
      if (error) throw error;
      setSubjects(prev => prev.map(subject => subject.id === id ? data[0] : subject));
      return { success: true, data: data[0] };
    } catch (error) {
      setError(error.message);
      console.error('Error updating subject:', error);
      return { success: false, error: error.message };
    }
  };

  const deleteSubject = async (id) => {
    try {
      const { error } = await supabase
        .from('subjects')
        .delete()
        .eq('id', id);
      
      if (error) throw error;
      setSubjects(prev => prev.filter(subject => subject.id !== id));
      return { success: true };
    } catch (error) {
      setError(error.message);
      console.error('Error deleting subject:', error);
      return { success: false, error: error.message };
    }
  };

  useEffect(() => {
    fetchSubjects();
  }, []);

  return {
    subjects,
    loading,
    error,
    addSubject,
    updateSubject,
    deleteSubject,
    refetch: fetchSubjects
  };
};